<template>
  <div class="systemuserlist-container">
    <div class="search-layout">
      <el-form :model="queryInfo" size="medium" :label-width="formLabelWidth('md')">
        <el-col :span="8">
          <el-form-item :label="$t('manage.name90')" prop="loginName">
            <el-cascader ref="refHandle" v-model="queryInfo.tenantIds" :placeholder="$t('public.name1')" :options="cascaderOptions" :style="$i18n.locale === 'en' ? 'width:360px' : ''" @change="handleChange" :props="{ lazy: true, lazyLoad: loadOptions }" clearable></el-cascader>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item :label="$t('manage.name1')" prop="keyword">
            <el-input v-model="queryInfo.keyword" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('manage.name2')" prop="status">
            <el-select v-model="queryInfo.status" :placeholder="$t('public.name1')" style="width:130px;">
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-form>
      <div>
        <el-button type="primary" size="medium" v-if="buttonPerms.indexOf('user/list') > -1" @click="getPageList">{{ $t('public.name3') }}</el-button>
        <el-button size="medium" @click="resetQueryInfo">{{ $t('public.name4') }}</el-button>
      </div>
    </div>
    <div class="add-user">
      <el-button type="primary" icon="el-icon-plus" size="medium" @click="addUser(null)" v-if="buttonPerms.indexOf('user/save') > -1">{{ $t('manage.name3') }}</el-button>
    </div>
    <el-table :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading">
      <el-table-column :label="$t('manage.name91')" prop="tenantName" sortable></el-table-column>
      <el-table-column :label="$t('manage.name4')" prop="loginName" sortable></el-table-column>
      <el-table-column :label="$t('manage.name5')" prop="userName" sortable></el-table-column>
      <el-table-column :label="$t('manage.name6')" prop="roleName" sortable></el-table-column>
      <el-table-column :label="$t('manage.name7')" prop="phone" sortable></el-table-column>
      <el-table-column :label="$t('manage.name8')" prop="email" sortable></el-table-column>
      <el-table-column :label="$t('manage.name9')" prop="updateTime" sortable width="170px">
        <template slot-scope="scope">
          {{ scope.row.updateTime | tzDisplay }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('manage.name10')" prop="loginDate" sortable width="170px">
        <template slot-scope="scope">
          {{ scope.row.loginDate | tzDisplay }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('manage.name11')" prop="loginIp" sortable width="150px"></el-table-column>
      <el-table-column :label="$t('manage.name12')" prop="status" sortable>
        <template slot-scope="scope">
          <div class="qiyong" v-if="scope.row.status">
            <div class="text">{{ $t('manage.name13') }}</div>
          </div>
          <div class="jinyong" v-else>
            <div class="text">{{ $t('manage.name14') }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('manage.name15')" width="188px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="addUser(scope.row)" v-if="buttonPerms.indexOf('user/update') > -1">{{ $t('manage.name17') }}</el-button>
          <el-button type="text" @click="delUser(scope.row)" v-if="buttonPerms.indexOf('user/delete') > -1" style="color:#ea4646">{{ $t('manage.name18') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <AppDialog
      width="400px"
      :title="franchiseeUsersInfo.userId === '' ? $t('manage.name102') : $t('manage.name103')"
      v-if="franchiseeUsersInfoDialog"
      :visible.sync="franchiseeUsersInfoDialog"
      :before-close="close"
    >
      <el-form ref="userFormRef" :model="franchiseeUsersInfo" :rules="franchiseeUsersInfo.userId === '' ? franchiseeUsersInfoRules : franchiseeUsersInfoRules1" :label-width="formLabelWidth('md2')">
        <el-form-item prop="tenantId" :label="$t('manage.name90')">
          <el-select v-model="franchiseeUsersInfo.tenantId" :placeholder="$t('public.name1')" style="width:100%;" clearable @change="changeTenant">
            <el-option v-for="item in franchiseNameOptions" :key="item.tenantId" :label="item.tenantName" :value="item.tenantId"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="loginName" :label="$t('manage.name20')">
          <el-input v-model="franchiseeUsersInfo.loginName" :placeholder="$t('public.name5')" :disabled="franchiseeUsersInfo.userId === '' ? false : true"></el-input>
        </el-form-item>
        <el-form-item prop="loginPwd" :label="$t('manage.name21')">
          <el-input v-model="franchiseeUsersInfo.loginPwd" :placeholder="$t('public.name5')" show-password :disabled="franchiseeUsersInfo.userId === '' ? false : true"> </el-input>
        </el-form-item>
        <el-form-item prop="userName" :label="$t('manage.name22')">
          <el-input v-model="franchiseeUsersInfo.userName" :placeholder="$t('public.name5')"></el-input>
        </el-form-item>
        <el-form-item prop="nickName" :label="$t('manage.name23')">
          <el-input v-model="franchiseeUsersInfo.nickName" :placeholder="$t('public.name5')"></el-input>
        </el-form-item>
        <el-form-item prop="phone" :label="$t('manage.name24')">
          <el-input v-model="franchiseeUsersInfo.phone" :placeholder="$t('public.name5')"></el-input>
        </el-form-item>
        <!-- <el-form-item prop="email" :label="$t('manage.name26')">
          <el-input v-model="franchiseeUsersInfo.email" :placeholder="$t('public.name5')"></el-input>
        </el-form-item> -->
        <el-form-item prop="roles" :label="$t('manage.name25')">
          <el-select v-model="franchiseeUsersInfo.roles" :placeholder="$t('public.name1')" style="width:100%;" clearable>
            <el-option v-for="item in rolesOptions" :key="item.roleId + ''" :label="item.roleName" :value="item.roleId + ''"> </el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="status" :label="$t('manage.name2')">
          <el-switch v-model="franchiseeUsersInfo.status" active-color="#0f73e6" inactive-color="#dcdfe6"> </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" :loading="loading">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </AppDialog>
  </div>
</template>
<script>
import { userList, tenantList, userSave, userUpdate, userDelete, sysroleList } from '@/api/manage.js'
import { validateEmail, validatePass } from '@/utils/utils.js'
import AppDialog from '@/components/AppDialog/index.vue'
export default {
  components: { AppDialog },
  computed: {
    statusOptions() {
      return [
        { value: 2, label: this.$t('operate.name98') },
        { value: 0, label: this.$t('operate.name48') },
        { value: 1, label: this.$t('operate.name39') }
      ]
    }
  },
  data() {
    return {
      tableLoading: false,
      loading: false,
      franchiseNameOptions: [],
      cascaderOptions: [],
      queryInfo: {
        tenantId: '',
        tenantIds: [],
        status: 2,
        keyword: '',
        page: 1,
        limit: 10
      },
      tableList: [],
      total: 0,
      franchiseeUsersInfoRules: {
        tenantId: [
          {
            required: true,
            message: this.$t('screen.name29'),
            trigger: 'blur'
          }
        ],
        loginName: [
          {
            required: true,
            validator: validateEmail,
            trigger: 'blur'
          }
        ],
        loginPwd: [
          {
            required: true,
            validator: validatePass,
            trigger: 'blur'
          }
        ],
        roles: [
          {
            required: true,
            message: this.$t('screen.name25'),
            trigger: 'blur'
          }
        ]
      },
      franchiseeUsersInfoRules1: {
        tenantId: [
          {
            required: true,
            message: this.$t('screen.name29'),
            trigger: 'blur'
          }
        ],
        loginName: [
          {
            required: true,
            validator: validateEmail,
            trigger: 'blur'
          }
        ],
        roles: [
          {
            required: true,
            message: this.$t('screen.name25'),
            trigger: 'blur'
          }
        ]
      },
      franchiseeUsersInfo: {
        userId: '',
        tenantId: '',
        loginName: '',
        loginPwd: '',
        userName: '',
        nickName: '',
        phone: '',
        email: '',
        roles: '',
        tenantType: 3,
        status: true
      },
      rolesOptions: [],
      franchiseeUsersInfoDialog: false,
      buttonPerms: ''
    }
  },
  created() {
    this.queryInfo.tenantIds.push(parseInt(this.$route.query.grandParentId))
    this.queryInfo.tenantIds.push(parseInt(this.$route.query.parentId))
    this.queryInfo.tenantIds.push(parseInt(this.$route.query.tenantId))
    this.queryInfo.tenantId = this.$route.query.tenantId
    this.buttonPerms = localStorage.getItem('buttonPerms')
  },
  mounted() {
    this.getManufacturerList()
    this.queryList()
  },
  methods: {
    getPageList() {
      this.queryInfo.page = 1
      this.queryInfo.limit = 10
      this.queryList()
    },
    queryList() {
      this.tableLoading = true
      const data = {
        page: this.queryInfo.page,
        limit: this.queryInfo.limit,
        tenantType: 3
      }
      if (this.queryInfo.keyword) {
        data.keyword = this.queryInfo.keyword.trim()
      }
      if (this.queryInfo.status !== 2) {
        data.status = this.queryInfo.status === 0
      }
      if (this.queryInfo.tenantId) {
        data.tenantId = this.queryInfo.tenantId
      }
      userList(data)
        .then(res => {
          this.tableList = res.data.list
          this.total = res.data.total
          this.tableLoading = false
        })
        .catch(() => {
          this.tableList = []
          this.total = 0
          this.tableLoading = false
        })
    },
    changeTenant(e) {
      this.getSysroleList(e)
    },

    getSysroleList(tenantId) {
      const data = {
        page: 1,
        limit: 500,
        tenantId: tenantId
      }
      sysroleList(data)
        .then(res => {
          this.rolesOptions = res.data.list
        })
        .catch(() => {})
    },
    resetQueryInfo() {
      this.queryInfo = {
        tenantId: '',
        tenantIds: [],
        status: 2,
        keyword: '',
        page: 1,
        limit: 10
      }
      this.queryList()
    },

    getManufacturerList() {
      const data = {
        page: 1,
        limit: 500,
        tenantType: 3
      }

      tenantList(data)
        .then(res => {
          this.franchiseNameOptions = res.data.list
        })
        .catch(() => {
          this.franchiseNameOptions = []
        })
    },
    addUser(row) {
      if (row !== null) {
        this.franchiseeUsersInfo = {
          userId: row.userId,
          tenantId: row.tenantId,
          loginName: row.loginName,
          loginPwd: '',
          userName: row.userName,
          nickName: row.nickName,
          phone: row.phone,
          email: row.email,
          roles: row.roleId,
          tenantType: 3,
          status: row.status
        }
        this.getSysroleList(row.tenantId)
      } else {
        if (this.queryInfo.tenantId) {
          this.franchiseeUsersInfo.tenantId = Number(this.queryInfo.tenantId)
          this.getSysroleList(this.queryInfo.tenantId)
        }
      }
      this.franchiseeUsersInfoDialog = true
    },

    delUser(row) {
      this.$confirm(this.$t('manage.name126'), this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          userDelete({
            id: row.userId + ''
          })
            .then(res => {
              if (res.code === 200) {
                this.$message({
                  type: 'success',
                  message: this.$t('public.name30')
                })
                this.queryInfo.page = 1
                this.queryList()
              }
            })
            .catch(() => {})
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('public.name31')
          })
        })
    },
    close() {
      this.franchiseeUsersInfo = {
        userId: '',
        tenantId: '',
        loginName: '',
        loginPwd: '',
        userName: '',
        nickName: '',
        phone: '',
        email: '',
        roles: '',
        tenantType: 3,
        status: true
      }
      this.rolesOptions = []
      this.franchiseeUsersInfoDialog = false
    },
    submitForm() {
      this.$refs.userFormRef.validate(async valid => {
        if (!valid) return
        this.loading = true
        if (this.franchiseeUsersInfo.userId) {
          userUpdate(this.franchiseeUsersInfo)
            .then(res => {
              if (res.code === 200) {
                this.loading = false
                this.close()
                this.queryInfo.page = 1
                this.queryList()
              }
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          userSave(this.franchiseeUsersInfo)
            .then(res => {
              if (res.code === 200) {
                this.loading = false
                this.queryInfo.page = 1
                this.close()
                this.queryList()
              }
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    },

    loadOptions(node, resolve) {
      console.log('===', node)

      let data = {
        page: 1,
        limit: 500,
        tenantType: 1
      }

      if (node.level === 1) {
        data = {
          page: 1,
          limit: 500,
          tenantType: 2,
          parentId: node.value
        }
      }
      if (node.level === 2) {
        data = {
          page: 1,
          limit: 500,
          tenantType: 3,
          parentId: node.value
        }
      }

      tenantList(data)
        .then(res => {
          if (res.data.list) {
            const options = res.data.list.map(item => ({
              value: item.tenantId,
              label: item.tenantName,
              leaf: node.level >= 2
            }))
            resolve(options)
          } else {
            resolve([])
          }
        })
        .catch(() => {})
    },
    handleChange(value) {
      // 处理选项变化
      this.queryInfo.tenantId = value[value.length - 1]
      const panelRefs = this.$refs.refHandle.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
      this.queryList()
    },

    handleSizeChange(newSize) {
      this.queryInfo.limit = newSize
      this.queryList()
    },
    // 监听页码值改变事件
    handleCurrentChange(newPage) {
      this.queryInfo.page = newPage
      this.queryList()
    }
  }
}
</script>
<style lang="scss" scoped>
.systemuserlist-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  .search-layout {
    width: 100%;
    display: flex;
    justify-content: space-between;

    // Keep controls flush after labels; space between search items (Permissions-like)
    ::v-deep .el-form-item__label {
      width: auto !important;
      padding-right: 8px;
      justify-content: flex-start !important;
      text-align: left !important;
    }

    ::v-deep .el-form-item__content {
      margin-left: 0 !important;
    }

    ::v-deep .el-col {
      padding-right: 32px;
      box-sizing: border-box;
    }

    ::v-deep .el-col:last-child {
      padding-right: 0;
    }
  }

  .qiyong {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #ebf6ed;
    color: #39ab4c;

    .text:before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 2px;
      background: #39ab4c;
      margin-right: 5px;
    }
  }

  .jinyong {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #fcecec;
    color: #ea4646;

    .text:before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 2px;
      background: #ea4646;
      margin-right: 5px;
    }
  }
}
</style>
